const checkOutStyles = {
  predefinedListStyle: {
    listStyleType: "disc",
    padding: "10px 10px 10px 30px",
  },
  predefinedListItem: {
    p: 0.5,
    display: "list-item",
    "::marker": {
      color: "#475569",
    },
  },
};

export default checkOutStyles;
